import React, { useState } from "react";

import { LockOutlined } from "@ant-design/icons";
import { Input } from "antd";

import * as String from "../commons/string";
import styles from "../pages/Login.module.css";

function InputPassword({ value, onChange }: { value?: string; onChange?: (value: string) => void }) {
    const [isCapsLock, setIsCapsLock] = useState(false);

    function onKeyDownHandler(e: any) {
        const checkCapsLock = e.getModifierState("CapsLock");
        setIsCapsLock(checkCapsLock);
    }

    return (
        <>
            <Input.Password
                className={styles.loginInput}
                prefix={<LockOutlined className="site-form-item-icon" />}
                type="password"
                placeholder={String.password}
                maxLength={20}
                onChange={(e) => {
                    if (onChange !== undefined) onChange(e.target.value);
                }}
                onKeyDown={onKeyDownHandler}
            />
            {isCapsLock && (
                <span className="capsLock" style={{ color: "#2871E6" }}>
                    Caps Lock이 켜져 있습니다.
                </span>
            )}
        </>
    );
}

export default InputPassword;
